import { useLocation } from 'react-router-dom'
import { PAGE_PARAM } from '../constants'

export const getPageParams = () => {
  const { search } = useLocation()
  const pageParam = new URLSearchParams(search).get(PAGE_PARAM)

  return pageParam ? Number(pageParam) : 1
}

export const getParams = () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  params.entries()
}
